/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAddressAddItem, IAddressAddUpdateProps } from '../../common/address/components/address-add';
import { IAddressList, IAddressListItem, IAddressListProps } from '../../common/address/components/address-list';
import { IAddressShowItem, IAddressShowProps } from '../../common/address/components/address-show';
import { IAccountManagementAddressViewProps } from './citta-account-management-address';
// import {ICittaAccountManagementAddressConfig} from "./citta-account-management-address.props.autogenerated";


const AddressShow: React.FC<IAddressShowProps> = ({
    AddressDetail,
    items
}) => {

    return (
        <Node {...AddressDetail}>
            {items && items.map((item: IAddressShowItem) => {
                return (
                    <>
                        {item.description}
                    </>
                );
            })}
        </Node>
    );
};

const AddressList: React.FC<IAddressList> = ({
    List,
    isShowList,
    heading,
    items
}) => {

    if (!isShowList) {
        return null;
    }

    return (
        <Node {...List}>
            {heading}
            {items && items.map((item: IAddressListItem) => {
                const { Item, key, error, showItems, isShowPrimaryButton, primaryButton, editButton, removeButton } = item;
                const { Error, isShowError, title, message } = error;
                return (<Node {...Item} key={key}>
                    <AddressShow  {...showItems} />
                    {isShowError && <Node {...Error}>
                        {title}
                        {message}
                    </Node>}
                    {isShowPrimaryButton && primaryButton}
                    {editButton}
                    {removeButton}
                </Node>);
            })}
        </Node>
    );
};

const AddressLists: React.FC<IAddressListProps> = ({
    ListAddress,
    heading,
    isShowEmptyListMessage,
    emptyListMessage,
    disclaimerMessage,
    addButton,
    primaryAddressList,
    otherAddressList
}) => {

    return (
        <Node {...ListAddress}>
            {heading}
            {disclaimerMessage}
            {isShowEmptyListMessage && emptyListMessage}
            {addButton}
            <AddressList {...primaryAddressList} />
            <AddressList {...otherAddressList} />
        </Node>
    );
};

const sortArray = (arr1: any[], arr2: any[]) => {
    arr2.sort((a, b) => {
       const aKey = a.key;
       const bKey = b.key;
       return arr1.indexOf(aKey) - arr1.indexOf(bKey);
    });
 };

const AddressAddUpdate: React.FC<IAddressAddUpdateProps> = ({
    AddressForm,
    heading,
    items,
    hasError,
    error,
    isShowSaveButton,
    saveButton,
    isShowCancelButton,
    cancelButton,
    searchAddress,
     //@ts-ignore
     countriesList
}) => {

    const order = ["Name", "ThreeLetterISORegionName",  "BuildingCompliment","StreetNumber", "Street", "DistrictName", "City", "State", "ZipCode", "Phone"]
    sortArray(order, items);
    let country: any = items.find(item => item.key === 'ThreeLetterISORegionName');
    if (countriesList && countriesList.length && country && country.input && country.input.props.displayData) {
        let res = country.input.props.displayData.filter((countryData: any) => countriesList.indexOf(countryData.key) !== -1)
        country.input.props.displayData = res;
    }

    return (
        <Node {...AddressForm}>
            {heading}
            {items && items.map((item: IAddressAddItem) => {
                const { AddressItem, key, label, alert, input } = item;
                return (<Node {...AddressItem} key={key}>
                    {label}
                    {alert}
                    {input}
                </Node>);
            })}
            {hasError && <Node {...error.AddressError}>
                {error.title}
                {error.message}
            </Node>}
            {searchAddress}
            {isShowSaveButton && saveButton}
            {isShowCancelButton && cancelButton}
        </Node>
    );
};

const AccountManagementAddressView: React.FC<IAccountManagementAddressViewProps> = props => {
    const { AccountAddressManagement, viewState, showAddressList, showAddOrUpdateAddress } = props;
    /* @ts-ignore */
    const { countriesList } = props.config;

    return (
        <Module {...AccountAddressManagement}>
            {viewState.isShowAddresList && <AddressLists {...showAddressList} />}
            {/* @ts-ignore */}
            {viewState.isShowAddOrUpdateAddress && <AddressAddUpdate {...showAddOrUpdateAddress} countriesList={countriesList}/>}
        </Module>
    );
};

export default AccountManagementAddressView;
